<template>
  <div>
    <v-app-bar
      flat
      color="transparent"
      class="main-appbar"
    >
      <app-bar-nav-icon />
      <div class="d-flex align-center">
        <v-toolbar-title>
          <h1 class="headline font-weight-bold">{{ pageTitle }}
          </h1>
        </v-toolbar-title>
      </div>
      <v-spacer />
      <div>
        <v-btn
          color="primary"
          class="mr-4"
          medium
          :disabled="form.$busy"
          @click="onCancel"
          text
          style="text-transform: none;"
        >Cancel</v-btn>
        <v-btn
          color="primary"
          medium
          @click="onSave"
          :loading="form.$busy"
          style="text-transform: none;"
        >Save</v-btn>
      </div>
    </v-app-bar>
    <v-row class="px-4 py-4">
      <v-col
        lg="8"
        md="6"
        sm="12"
        xs="12"
      >
        <v-card
          outlined
          class="px-6 py-8"
        >
          <v-text-field
            outlined
            flat
            label="Name"
            required
            v-model="form.name"
            :error-messages="form.$getError('name')"
          />

          <sport-selector
            v-model="form.tag_type"
            :disabled="loadingTags"
            @change="tagTypeChanged"
            :error-messages="replace(head(form.$getError('tag_type')), 'tag type', 'sports')"
          />

          <league-selector
            v-model="form.tag_name"
            :tagType="form.tag_type"
            @loadingState="state => this.loadingTags = state"
            @change="e => this.form.$clearError('tag_name')"
            :error-messages="replace(head(form.$getError('tag_name')), 'tag name', 'league')"
          />

          <v-text-field
            outlined
            flat
            label="Code"
            required
            v-model="form.hp_abbreviation_code"
            :error-messages="form.$getError('hp_abbreviation_code')"
          />
        </v-card>
      </v-col>
      <v-col
        lg="4"
        md="6"
        sm="12"
      >
        <slug-generator
          ref="slugGenerator"
          :base-string="form.title"
          v-model="slug"
          :error-messages="form.$getError('slug')"
        />
      </v-col>
    </v-row>
  </div>
</template>

<script>
import LeagueSelector from '@/views/Home/Articles/shared/LeagueSelector'
import AppBarNavIcon from '@/layouts/shared/AppBarNavIcon'
import Form from '@/utils/form'
import get from 'lodash/get'
import head from 'lodash/head'
import replace from 'lodash/replace'
import SlugGenerator from '@/components/SlugGenerator'
import Team from '@/models/Team'
import map from 'lodash/map'
import slugify from 'slugify'
import SportSelector from '@/views/Home/Articles/shared/SportSelector'

const initialData = {
  name: null,
  tag_name: null,
  tag_type: null,
  sport: null,
  slug: null,
  hp_abbreviation_code: null
}

export default {
  data () {
    return {
      form: new Form({
        ...initialData
      }),
      snackbar: {
        show: false,
        message: null,
        color: 'success'
      },
      loadingTags: false
    }
  },
  components: {
    AppBarNavIcon,
    LeagueSelector,
    SlugGenerator,
    SportSelector
  },
  props: {
    team_player: {
      type: [Team, Object],
      default () {
        return {}
      }
    },
    pageTitle: {
      type: String,
      default: 'Add new Team or Player'
    },
    redirectCancelTo: {
      type: [String, Object],
      default () {
        return {
          name: 'teams-and-players'
        }
      }
    },
    redirectSaveTo: {
      type: [String, Object],
      default () {
        return {
          name: 'teams-and-players'
        }
      }
    }
  },
  methods: {
    head,
    replace,
    onCancel () {
      this.$router.replace(this.redirectCancelTo)
    },
    async onSave () {
      try {
        this.form.$busy = true
        this.form.$clearErrors()
        const data = this.form.$data()
        data.slug = data.slug ? data.slug : this.slug

        if (data.tag_name.length === 0) delete data.tag_name
        const team = new Team(data)
        await team.save()
        // await this.executeOnUpdate()
        this.$router.replace(this.redirectSaveTo)
      } catch (error) {
        if (get(error, 'response.status') === 422) {
          if (get(error, 'response.data.errors') !== null) {
            this.form.$setErrors(get(error, 'response.data.errors'))
          } else {
            this.showSnackbar('Something went wrong.', 'error')
          }
        } else {
          this.showSnackbar(error, 'error')
        }
      } finally {
        this.form.$busy = false
      }
    },
    showSnackbar (message, color = 'success') {
      this.snackbar.message = message
      this.snackbar.show = true
      this.snackbar.color = color
    },
    tagTypeChanged () {
      this.$set(this.form, 'tag_name', null)
      this.form.$clearError('tag_name')
      this.form.$clearError('tag_type')
    }
  },
  watch: {
    team_player: {
      immediate: true,
      handler (val) {
        if (val) {
          this.form = new Form({
            ...initialData,
            ...val,
            tag_type: get(val, 'tags.0.type', '').toLowerCase(),
            tag_name: map(val.tags, 'name')
          })

          if (!this.form.slug) {
            this.$nextTick(() => this.$refs['slugGenerator'].generate())
          }
        }
      }
    }
  },
  computed: {
    slug: {
      get () {
        if (this.form.slug && this.form.slug.trim() !== '') {
          return this.form.slug
        }

        if (this.form.name) {
          return slugify(this.form.name, {
            remove: /[*+~.()'"!:@]/g,
            lower: true,
            strict: true
          })
        }

        return null
      },
      set (v) {
        this.form.slug = v
      }
    },
    isModeUpdate () {
      return get(this.form, 'id', null) !== null
    }
  }
}
</script>
